<template>
  <b-row align-h="center">
    <b-col cols="10" lg="8" class="btb-contact-find my-4 py-4">
      <b-form @submit.prevent="searchForContact" ref="contactForm" novalidate>
        <b-form-group class="mb-4"
          :label="formConfig.email.label"
          :label-for="formConfig.email.id"
          :state="emailState"
        >
          <b-form-input
            :id="formConfig.email.id"
            v-model="formData.email"
            ref="email"
            :required="formConfig.email.required"
            :state="emailState"
            :type="formConfig.email.type"
            trim
          />
        </b-form-group>
        <b-form-group class="mb-4" :state="phoneState"
          :label="formConfig.phone.label"
          :label-for="formConfig.phone.id"
        >
          <b-form-input
            :id="formConfig.phone.id"
            v-model="formData.phone"
            ref="phone"
            :required="formConfig.phone.required"
            :state="phoneState"
            :type="formConfig.phone.type"
            trim
          />
        </b-form-group>
        <b-form-checkbox
          v-bind="formConfig.smsOptin"
          v-model="formData.smsOptin"
        >
          <span class="text-muted">{{ formConfig.smsOptin.label }}</span>
        </b-form-checkbox>
        <b-button class="mt-4"
          type="submit" 
          :variant="formConfig.submit.variant"
        >
          {{ formConfig.submit.text }}
        </b-button>
      </b-form>
    </b-col>
    
    <b-modal :id="personSelectModalId"
      centered 
      :hide-footer="true" 
      size="lg" 
      title="Profile Detail"
    >
      <b-container>
        <header class="h6">
          <p>We found a profile associated with that email.</p>
          <p>Please select the profile which is yours.</p>
        </header>
        <b-row class="font-bold">
          <b-col>Full Name</b-col>
          <b-col>Date of Birth</b-col>
          <b-col>Phone Number</b-col>
          <b-col>This is me</b-col>
        </b-row>
        <b-row align-v="center" class="my-2"
          v-for="person in foundPeople"
          :key="person.id"
        >
          <b-col>{{ getDisplayName(person) }}</b-col>
          <b-col>{{ person.date_of_birth | obfuscateDob }}</b-col>
          <b-col>{{ person.phone | obfuscatePhone }}</b-col>
          <b-col>
            <b-button variant="outline-primary" class="" @click="selectPersonFromList(person)">
              Select
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-row>
</template>

<script>
import { getDisplayName } from '@/utils';
import { FETCH_PEOPLE } from '@/store/actions';
import { UPDATE_PERSON, UPDATE_SMS_OPTIN } from '@/store/mutations';
import { phoneRegex, emailRegex, validateEmail, validatePhone } from '@/utils';

export const FIND_CONTACT_EVENTS = {
  COMPLETED: 'findContact:Completed'
}

export default {
  props: {
    showing: {
      type: Boolean,
    }
  },
  data () {
    const formConfig = {
      email: {
        id: 'contact-email',
        label: 'Email Address',
        model: 'email',
        placeholder: 'Enter Email Address',
        required: true,
        type: 'email',
      },
      phone: {
        id: 'contact-phone',
        label: 'Phone Number',
        model: 'phone',
        placeholder: 'Enter Phone Number',
        required: true,
        type: 'tel',
      },
      smsOptin: {
        id: 'contact-sms-optin',
        label: 'By checking this box, you consent to receiving SMS messages with your free photos & videos along with additional marketing communications. You may opt out at any time in the future.',
        name: 'contact-sms-optin',
        value: true,
        'unchecked-value': false
      },
      submit: {
        text: 'Search',
        variant: 'outline-primary'
      }
    }
    return {
      formConfig,
      formData: {
        email: null,
        phone: null,
        smsOptin: true,
      },
      foundPeople: null,
      formSubmitted: false
    }
  },
  computed: {
    canSubmit () {
      for (const key in this.formData) {
        if (key === 'smsOptin') continue; // NOTE: ignore smsOptin for validation
        if (!this.formData[key]?.length) return false;
      }
      if (!this.phoneValid || !this.emailValid) return false;
      return true;
    },
    personSelectModalId () {
      return 'person-select-modal';
    },
    emailRegex () { return emailRegex },
    emailState () {
      return this.formSubmitted ? this.emailValid : null
    },
    phoneRegex () { return phoneRegex },
    phoneState () {
      return this.formSubmitted ? this.phoneValid : null
    },
    emailValid () {
      if (this.formData.email?.length) return validateEmail(this.formData.email)
      return false
    },
    validateEmailFeedback () {
      return 'Please enter a valid email address'
    },
    phoneValid () {
      if (this.formData.phone?.length) return validatePhone(this.formData.phone)
      return false
    },
  },
  watch: {
    showing (fresh) {
      fresh && this.focusPrimaryInput()
    }
  },
  methods: {
    getDisplayName,
    focusPrimaryInput () {
      this.$refs.email.focus()
    },
    formCompleted () {
      this.$emit(FIND_CONTACT_EVENTS.COMPLETED);
    },
    async searchForContact () {
      this.formSubmitted = true
      if (!this.canSubmit) return
      if (!this.$refs.contactForm.checkValidity()) return;
      this.$store.commit(UPDATE_SMS_OPTIN, this.formData.smsOptin)
      const foundPeople = await this.$store.dispatch(FETCH_PEOPLE, { ...this.formData });
      if (foundPeople.length) {
        // show modal with people
        this.foundPeople = foundPeople;
        this.$bvModal.show(this.personSelectModalId);
      } else {
        const { smsOptin, ...details } = this.formData
        console.warn(`No person found in the DB with details:`, details)
        this.$store.commit(UPDATE_PERSON, details)
        this.formCompleted()
      }
      
    },
    async selectPersonFromList (person) {
      // const confirmed = await this.showConfirmationModal()
      // if (confirmed) {
      //   this.$store.commit(UPDATE_PERSON, person);
      //   this.$bvModal.hide(this.personSelectModalId);
      //   this.formCompleted();
      // } else {
      //   this.$store.commit(UPDATE_SMS_OPTIN, false);
      // }
      const { email, phone } = this.formData
      this.$store.commit(UPDATE_PERSON, { ...person, email, phone })
      this.formCompleted()
    },
    // async showConfirmationModal () {
    //   const h = this.$createElement;
    //   const confirmVNode = h('div', {}, [
    //     h('p', { class: ['btb-query']}, 'Is this you?'),
    //     h('b-row', { }, [
    //       h('b-col', { class: ['font-bold'], props: { cols: 'auto' } }, [
    //         h('div', 'Date of Birth:'),
    //         h('div', 'Phone:')
    //       ]),
    //       h('b-col', {}, [
    //         h('div', `${ this.$options.filters.obfuscateDob(person.date_of_birth) }`),
    //         h('div', {}, `${ this.$options.filters.obfuscatePhone(person.phone) }`),
    //       ]),
    //     ]),
    //   ])
    //   const confirmed = await this.$bvModal.msgBoxConfirm(confirmVNode, {
    //     title: `You selected: ${ this.getDisplayName(person) }`,
    //     okTitle: 'Confirm',
    //     hideHeaderClose: true,
    //   });

    //   return confirmed
    // },
  },
  filters:{
    obfuscateDob (dob) {
      if (!dob) return 'N/A';

      const mmdd = dob.slice(-5);
      return `${ mmdd }-****`;
    },

    obfuscatePhone (phone) {
      if (!phone) return 'N/A';
      return `***-***-${ phone.slice(-4) }`
    },

  },
}
</script>

<style scoped>
.btb-contact-find {
  background-color: var(--bs-gray-400);
  border: 1px solid var(--bs-info);
}
</style>